/**
 * ───────────────────────────────────────────────────────────────────
 *  YOUR CONTENT LIVES HERE.
 *  Edit this file to make the portfolio yours. Nothing else is required.
 *  Each command (/about, /skills, /projects, /social) reads from this.
 * ───────────────────────────────────────────────────────────────────
 */

export interface Skill {
  name: string;
  /** 0–100, drives the little progress bar */
  level: number;
}

export interface SkillGroup {
  label: string;
  skills: Skill[];
}

export interface Project {
  name: string;
  description: string;
  tech: string[];
  /** Optional links shown under the project */
  link?: string;
  repo?: string;
}

export interface Social {
  label: string;
  /** what gets shown / opened, e.g. a URL or handle */
  value: string;
  url?: string;
}

export interface Profile {
  handle: string; // shows in the prompt:  handle@host:~$
  host: string;
  name: string;
  role: string;
  location: string;
  /** Each string is a paragraph in /about */
  about: string[];
  skillGroups: SkillGroup[];
  projects: Project[];
  socials: Social[];
}

export const profile: Profile = {
  handle: "javen",
  host: "javen.dev",
  name: "Jan",
  role: "Full-stack engineer · Game developer · Open-source enthusiast",
  /** Deliberate, not an unfilled default — it reads better than a city. */
  location: "Earth, UTC+1",

  about: [
    "Hey there! I'm Jan aka Javen, a full-stack engineer passionate about building fast, thoughtful software.",
    "I have a deep passion for self hosting and game development, and I love exploring new technologies and paradigms.",
    "From hardware to software, I enjoy tinkering with all aspects of technology. I believe in the power of open-source.",
    "Always open to collaborate and connect with like-minded individuals. Let's create something amazing together!",
  ],

  skillGroups: [
    {
      label: "Languages",
      skills: [
        { name: "C#", level: 95 },
        { name: "C++", level: 80 },
        { name: "Python", level: 85 },
        { name: "HTML/CSS", level: 70 },
      ],
    },
    {
      label: "Game Engines & tools",
      skills: [
        { name: "Unity", level: 90 },
        { name: "Unreal Engine", level: 70 },
        { name: "Godot", level: 60 },
        { name: "Blender", level: 80 },
        { name: "Git", level: 90 },
      ],
    },
    {
      label: "Frontend",
      skills: [
        { name: "TypeScript", level: 90 },
        { name: "React", level: 70 },
      ],
    },
    {
      label: "Backend & infra",
      skills: [
        { name: "Bun", level: 80 },
        { name: "Node.js", level: 70 },
        { name: "Docker/Podman", level: 80 },
        { name: "PostgreSQL", level: 70 },
      ],
    },
  ],

  projects: [
    {
      name: "Deepfake Detective",
      description: "An educational game that teaches players to spot deepfakes and misinformation online.",
      tech: ["Unity", "C#", "Blender"],
      link: "https://www.techagogics.de/workshop/deepfake-detective",
    },
    {
      name: "I:Sol",
      description: "An atmospheric stealth game where you explore a derelict colony on a distant planet, uncovering its secrets and surviving against hostile forces.",
      tech: ["Unreal Engine", "C++", "Blender"],
      link: "https://teaminstable.itch.io/isol",
    }
  ],

  socials: [
    { label: "github", value: "JaXVen", url: "https://github.com/JaXVen" },
    { label: "linkedin", value: "Jan", url: "https://www.linkedin.com/in/jan-vollertsen/" },
    { label: "itch.io", value: "Javen Indie", url: "https://javen-indie.itch.io/" },
  ],
};
